import { Col } from "react-grid-system";
import styled from "styled-components";

export const StyledDecisionFooter = styled(Col)`
	display: flex;
	flex-wrap: wrap;
	column-gap: 1.6rem;
	row-gap: 1.6rem;
`;
